var _g, _circle, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGridImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 614,
    height: 508,
    viewBox: "0 0 614 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 42.3906,
    y1: 17.1875,
    x2: 42.3907,
    y2: 507.163,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.0078,
    y1: 7.16406,
    x2: 84.0078,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.633,
    y1: 7.16406,
    x2: 125.633,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.258,
    y1: 7.16406,
    x2: 167.258,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.875,
    y1: 7.16406,
    x2: 208.875,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.5,
    y1: 7.16406,
    x2: 250.5,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.125,
    y1: 7.16406,
    x2: 292.125,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.742,
    y1: 7.16406,
    x2: 333.742,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.367,
    y1: 7.16406,
    x2: 375.367,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.992,
    y1: 7.16406,
    x2: 416.992,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.609,
    y1: 7.16406,
    x2: 458.609,
    y2: 507.164,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 46.9141,
    x2: -4.34612e-8,
    y2: 46.914,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 88.7773,
    x2: -4.34612e-8,
    y2: 88.7773,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 130.641,
    x2: -4.34612e-8,
    y2: 130.641,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 172.5,
    x2: -4.34612e-8,
    y2: 172.5,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 214.363,
    x2: -4.34612e-8,
    y2: 214.363,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 256.227,
    x2: -4.34612e-8,
    y2: 256.227,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 298.086,
    x2: -4.34612e-8,
    y2: 298.086,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 339.949,
    x2: -4.34612e-8,
    y2: 339.949,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 381.812,
    x2: -4.34612e-8,
    y2: 381.812,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 423.672,
    x2: -4.34612e-8,
    y2: 423.672,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 465.535,
    x2: -4.34612e-8,
    y2: 465.535,
    stroke: "#7551FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 321.024,
    cy: 362.945,
    r: 1.78137,
    fill: "#7551FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1355_24396)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.082,
    cy: 202.839,
    rx: 91.8916,
    ry: 194.968,
    transform: "rotate(-135 411.082 202.839)",
    fill: "url(#paint0_linear_1355_24396)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1355_24396",
    x: 256.836,
    y: 48.5898,
    width: 308.492,
    height: 308.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1355_24396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1355_24396",
    x1: 330.311,
    y1: 77.9425,
    x2: 527.683,
    y2: 268.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGridImage1);
export default __webpack_public_path__ + "static/media/RightGridImage1.6ab10b536116c760f7a0283b7160ae32.svg";
export { ForwardRef as ReactComponent };